import React, { useState } from "react";
import DrawerFilter from "../../../components/listing/DrawerFilter";
import ContratoAutocomplete from "../../../components/autocomplete/ContratoAutocomplete";
import TarjetasAutocomplete from "../../../components/autocomplete/TarjetasAutocomplete";
import EstadoSelect from "../../../components/select/EstadoSelect";

export default function FiltroContratoTarjeta({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // Inicialización directa con los valores recibidos (si existen)
  const [contratoObj, setContratoObj] = useState(initialFilters.contratoObj || null);
  const [tarjetaObj, setTarjetaObj] = useState(initialFilters.tarjetaObj || null);
  const [estadoObj, setEstadoObj] = useState(initialFilters.estadoObj || null);
  const [isLoading, setIsLoading] = useState(false);

  const handleApply = () => {
    setIsLoading(true);
    onSubmit({
      contratoObj,
      tarjetaObj,
      estadoObj,
    });
    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Asignación Contrato‑Tarjeta"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* Contrato */}
      <div>
        <label className="form-label-fil">Contrato:</label>
        <div className="mt-1 w-full">
          <ContratoAutocomplete
            value={contratoObj}
            onChange={setContratoObj}
            placeholder="Buscar por código..."
          />
        </div>
      </div>

      {/* Tarjeta */}
      <div>
        <label className="form-label-fil">Tarjeta:</label>
        <div className="mt-1 w-full">
          <TarjetasAutocomplete
            value={tarjetaObj}
            onChange={setTarjetaObj}
            placeholder="Buscar por número..."
          />
        </div>
      </div>

      {/* Estado */}
      <div>
        <label className="form-label-fil">Estado:</label>
        <EstadoSelect
          tipoId={20}
          value={estadoObj}
          onChange={setEstadoObj}
          autoLoad={true}
        />
      </div>
    </DrawerFilter>
  );
}